import React from "react";
import styles from "./InfoWithButtonSection.module.scss";
import { Button } from "@onegovbugs/onegov-react-components";

const DownloadSection = (props) => (
  <>
    <div className={`${styles.editSection}`}>
      <div className={`row`}>
        <div className={"col-8"}>
          <p><label>{props.title}</label></p>
          <p>{props.info}</p>
        </div>
        <div className={`col-4 ${styles.editButtonCont}`}>
          <Button
            onClick={() => props.onClick()}
            secondary
            className={styles.editButton}
          >
            {props.buttonCopy ?? "Download"}
          </Button>
        </div>
      </div>
    </div>
  </>
);

export default DownloadSection;
